import React from "react";
import { Box, Paginator } from "@tiny/components";

import { useSearchPanelFooter } from "./SearchPanelFooter.hooks";

function SearchPanelFooter() {
  return <SearchPanelFooterComponent {...useSearchPanelFooter()} />;
}

const SearchPanelFooterComponent = React.memo(
  (props: ReturnType<typeof useSearchPanelFooter>) => {
    const {
      itemsPerPage,
      itemsPerPageOptions,
      onItemsPerPageChange,
      onPageChange,
      page,
      totalCount,
      mdUp,
    } = props;

    return (
      <Box
        pl={mdUp ? 6 : 4}
        pr={mdUp ? 6 : 4}
        pt={mdUp ? 4 : 3}
        pb={mdUp ? 4 : 3}
      >
        <Paginator
          itemsPerPage={itemsPerPage}
          itemsPerPageLabel="Results"
          itemsPerPageOptions={itemsPerPageOptions}
          onItemsPerPageChange={onItemsPerPageChange}
          onPageChange={onPageChange}
          page={page}
          totalCount={totalCount}
        />
      </Box>
    );
  }
);

export default SearchPanelFooter;
